import { useEffect, useState } from 'react';

import usePersonCertificationData from '../../../../state/landingPages/personCertification/UsePersonCertificationData';
import useLandingPageData from '../../../../state/landingPages/UseLandingPageData';

const INITIAL_STATE = {
  certifications: [],
  isLoading: true
};

// swims/person/{personId}/certifications
const useMyCertifications = () => {
  const { landingPageState } = useLandingPageData();
  const { personCertificationState, getPersonCertificationsByPersonId } = usePersonCertificationData();
  const [state, setState] = useState(INITIAL_STATE);

  useEffect(() => {
    if (landingPageState.currentPerson?.personId) {
      getPersonCertificationsByPersonId(landingPageState.currentPerson?.personId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [landingPageState.currentPerson?.personId]);

  useEffect(() => {
    if (personCertificationState.isArrayLoading === false && personCertificationState.isArrayLoaded === true) {
      setState({
        certifications: personCertificationState.arrayData || [],
        isLoading: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personCertificationState]);

  return {
    ...state
  };
};

export default useMyCertifications;